import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { downloadExcelFile } from "../actions/backOfficeAction"; // Adjust path
import { useDispatch } from "react-redux";
import DOMPurify from 'dompurify';

const UploadStatus = ({ show, closeDialog, message}) => {// Add fileName and fileUrl props
    // Function to extract file name from the message
    const extractFileNameFromMessage = (message) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = message;

        const link = tempDiv.querySelector("a");
        if (link) {
            const href = link.getAttribute("href");
            if (href) {
                const fileName = href.split("/").pop();
                return fileName;
            }
        }
        return null;
    };

    const extractFileUrlFromMessage = (message) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = message;

        const link = tempDiv.querySelector("a");
        if (link) {
            const href = link.getAttribute("href");
            return href || null; // Return the full URL if it exists
        }
        return null; // Return null if no link is found
    };

    // Extract file name dynamically and set hasLink to true if link is found
    const fileName = extractFileNameFromMessage(message);
    const fileUrl = extractFileUrlFromMessage(message);
    const haslink = /<a\s+[^>]*href=/i.test(message);
    console.log("Message contains a hyperlink URL", haslink);

    const handleDownload = () => {
        console.log(`Downloading file: ${fileName}`);
        console.log(`File URL: ${fileUrl}`);
        if (fileUrl) {
            dispatch(downloadExcelFile(fileUrl))
            //saveAs(fileUrl, fileName); // Use the file-saver library to download the file
        }
    };
    const dispatch = useDispatch();

    // Attach click event to dynamically rendered links
    useEffect(() => {
        const container = document.getElementById("dynamic-content");

        // Define handleLinkClick inside the useEffect
        const handleLinkClick = (event) => {
            event.preventDefault(); // Prevent default hyperlink navigation

            const target = event.target.closest("a"); // Ensure we get the correct <a> element
            if (!target) return; // Exit if the click is not on a link

            const href = target.getAttribute("href"); // Extract href value
            const linkType = target.getAttribute("data-type"); // Extract 'data-type' attribute

            if (linkType === "download" && href) {
                console.log(`Dispatching download of file: ${href}`);
                dispatch(downloadExcelFile(href)); // Dispatch action to download the file
            } else {
                console.log(`Clicked a non-download link: ${href}`);
            }
        };

        if (container) {
            container.addEventListener("click", handleLinkClick); // Attach event listener
        }

        // Cleanup function to remove the event listener
        return () => {
            if (container) {
                container.removeEventListener("click", handleLinkClick);
            }
        };
    }, [message, dispatch]); // Re-run effect only if `message` or `dispatch` changes

    return (
      <Modal
          show={show}
          onHide={closeDialog}
          id="loadSuccessMessage"
          backdrop="static"
          keyboard={false}
      >
        <Modal.Header>
        <span className="close" onClick={closeDialog}>
            X
        </span>
          <div className="success-header-text">
             { haslink? "SUCCESS with ERRORS" : "SUCCESS" }
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* Render dynamic content */}
          <div
              id="dynamic-content"
              //dangerouslySetInnerHTML={{ __html: message }}
              dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(message.replace(/<a\b[^>]*>(.*?)<\/a>/gi, ''), {
                      ALLOWED_TAGS: ['b', 'i', 'strong', 'em', 'p', 'br', 'div'], // Allow only specific tags
                      ALLOWED_ATTR: [] // Remove all attributes to ensure safety
                  }),
              }}
          />
            {/* New download button */}
            {fileName && fileUrl && (
                <div className="download-container">
                    <button
                        className="gcotg-button"
                        onClick={handleDownload}
                    >
                        DOWNLOAD ERROR FILE
                    </button>
                </div>
            )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="gcotg-button" onClick={closeDialog}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
  );
};

export default UploadStatus;